import { Facebook, Linkedin } from "lucide-react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { NAV_LINKS, LOGO } from "@/lib/content";

export const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const goToHash = (e, href) => {
    e.preventDefault();
    const id = href.replace("#", "");
    if (location.pathname !== "/") {
      navigate("/");
      let tries = 0;
      const t = setInterval(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
          clearInterval(t);
        } else if (++tries > 40) {
          clearInterval(t);
        }
      }, 50);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-[#F1F1F3] border-t border-[#E5E7EB] text-[#1F2937]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 pt-[27px] pb-[49px] lg:py-16">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10 lg:gap-16">
          <div className="md:-mt-3">
            <img
              src={LOGO}
              alt="Home Cart — Everything for Every Home"
              className="h-20 w-auto"
            />
            <p className="font-body text-sm text-[#6B6B66] mt-5 max-w-sm leading-relaxed">
              Trusted brands, everyday essentials and exceptional
              <br className="hidden md:block" /> value across Canada.
            </p>
          </div>

          <div className="flex items-end md:items-start gap-12 lg:gap-20">
            <div>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3 mb-[10px] sm:mb-0">
                {NAV_LINKS.map((l) =>
                  l.href.startsWith("/") ? (
                    <li key={l.label}>
                      <Link
                        to={l.href}
                        className="font-body text-sm text-[#6B6B66] transition-colors hover:text-[#F8B808]"
                      >
                        {l.label}
                      </Link>
                    </li>
                  ) : (
                    <li key={l.label}>
                      <a
                        href={l.href}
                        onClick={(e) => goToHash(e, l.href)}
                        className="font-body text-sm text-[#6B6B66] transition-colors hover:text-[#F8B808]"
                      >
                        {l.label}
                      </a>
                    </li>
                  )
                )}
              </ul>
            </div>

            <div className="translate-x-12 -translate-y-4 md:translate-x-0 md:translate-y-0">
              <ul className="space-y-3 font-body text-sm text-[#6B6B66]">
                <li>info@homecart.ca</li>
              </ul>
              <div className="flex items-center gap-3 mt-5">
                <a
                  href="#top"
                  data-testid="social-facebook"
                  className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#F5F5F5] transition-colors hover:bg-[#F8B808]"
                  aria-label="Facebook"
                >
                  <Facebook className="h-4 w-4 text-[#1A1A1A]" />
                </a>
                <a
                  href="#top"
                  data-testid="social-linkedin"
                  className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#F5F5F5] transition-colors hover:bg-[#F8B808]"
                  aria-label="LinkedIn"
                >
                  <Linkedin className="h-4 w-4 text-[#1A1A1A]" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-[36px] lg:mt-14 pt-7 border-t border-[#E5E7EB] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-body text-sm text-[#9A958C]">
            © {new Date().getFullYear()} Home Cart. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/privacy"
              data-testid="footer-privacy"
              className="font-body text-sm text-[#6B6B66] hover:text-[#F8B808] transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              data-testid="footer-terms"
              className="font-body text-sm text-[#6B6B66] hover:text-[#F8B808] transition-colors"
            >
              Terms of Use
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
